export function initSinglePageNavigation(){
    const nav = document.querySelector('.pc_sp_interactive_nav');
    if (!nav) return;

    const navItems = Array.from(nav.querySelectorAll<HTMLElement>('[data-id-for]'));

    function updateActiveNav() {
        let firstInView: HTMLElement | null = null;
        navItems.forEach(item => {
            const id = item.getAttribute('data-id-for');
            if (!id) return;
            const target = document.getElementById(id);
            if (!target) return;
            const rect = target.getBoundingClientRect();
            const inView = rect.top < window.innerHeight && rect.bottom > 0;
            if (inView && !firstInView) {
                firstInView = item;
            }
        });

        navItems.forEach(item => {
            if (item === firstInView) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });
    }

    window.addEventListener('scroll', updateActiveNav, { passive: true });
    window.addEventListener('resize', updateActiveNav);
    updateActiveNav();
}
